import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getGsts } from "../../services/gstService";
import { toast } from "react-toastify";

const initialState = {
  gsts: [],
  total: 0,
  page: 1,
  totalRechargeAmount: 0,
  status: "idle", // "idle" | "loading" | "succeeded" | "failed"
  error: null,
};

// Fetch all gsts
export const fetchGsts = createAsyncThunk(
  "gsts/fetchGsts",
  async (
    { page, search, startDate, endDate, includeTotal = false },
    { rejectWithValue },
  ) => {
    try {
      const response = await getGsts(
        page,
        search,
        startDate,
        endDate,
        includeTotal,
      );
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(
        error.response?.data?.message || "An error occurred",
      );
    }
  },
);

const gstSlice = createSlice({
  name: "gsts",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Gsts
      .addCase(fetchGsts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchGsts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.gsts = action.payload.data.recharges;
        state.total = action.payload.data.total;
        state.page = action.payload.data.page;
        state.totalRechargeAmount =
          action.payload.data.totalRechargeAmount ?? 0;
      })
      .addCase(fetchGsts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = gstSlice.actions;
export default gstSlice.reducer;
